import { createAction } from 'redux-actions';

import { OPEN, CLOSE } from 'apps/shared/features/modal/constants';

export const openModal = createAction(OPEN);
export const closeModal = createAction(CLOSE);
